export const mapOptions = {
    styles: [
      {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [{ "color": "#7c93a3" }, { "lightness": "-10" }]
      },
      {
        "featureType": "poi",
        "elementType": "labels.icon",
        "stylers": [
          { "visibility": "on" },
          { "color": "#6c6c6c" },
        ]
      },
      {
        "featureType": "administrative.country",
        "elementType": "geometry",
        "stylers": [{ "visibility": "on" }]
      },
      {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [{ "color": "#f5f5f2" }]
      },
      {
        "featureType": "landscape.man_made",
        "elementType": "geometry",
        "stylers": [{ "color": "#eaeaea" }]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [{ "color": "#679d7b" }]
      },
      {
        "featureType": "poi.school",
        "elementType": "labels.icon",
        "stylers": [{ "visibility": "on" }, { "color": "#6c6c6c" }]
      },
      {
        "featureType": "poi.medical",
        "elementType": "labels.icon",
        "stylers": [{ "visibility": "on" }, { "color": "#6c6c6c" }]
      },
      {
        "featureType": "poi.business",
        "elementType": "labels.icon",
        "stylers": [{ "visibility": "off" }]
      },
      {
        "featureType": "poi.attraction",
        "elementType": "labels.icon",
        "stylers": [{ "visibility": "on" }, { "color": "#6c6c6c" }]
      },
      {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [{ "color": "#ffffff" }]
      },
      {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [{ "color": "#ffffff" }]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [{ "color": "#a6b5db" }]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [{ "color": "#acd5f5" }]
      },
      {
        "featureType": "transit.station",
        "elementType": "labels.icon",
        "stylers": [
          { "visibility": "on" },
          { "saturation": -50 },
          { "lightness": 30 },
          { "gamma": 0.8 },
          { "weight": 1 }
        ]
      },
      {
        "featureType": "transit.station",
        "elementType": "labels.text.fill",
        "stylers": [{ "color": "#4d7bbd" }]
      },
    ],
    disableDefaultUI: true,
    zoomControl: true,
  };
